import { SET_REFERENTIEL } from '../action/action'; 

const initialState = {
	referentiel: null	
}

const setReferentielReducer = (state = initialState, action) => {
	let nextState;

	switch (action.type) {
		case SET_REFERENTIEL: {
			nextState = {
				referentiel: action.value
			}
			return nextState || state
		}
	
		default:
			return state;
	}
}

export default setReferentielReducer;